import React, { useEffect } from "react";
import { Container, Carousel } from "react-bootstrap";
import "../../../styles/FieldDrop.css";
import CardItems from "./CardItems";
import useFieldDropIndex from "./hooks/useFieldDropIndex";
import useSeenFieldDropChildren from "./hooks/useSeenFieldDropChildren";

/**
 * FieldDrop component displays a carousel or single card for dropped/sponsored children.
 * Handles tracking of seen children and navigation to child history.
 *
 * @param {Array} data - Array of child card data
 * @param {Function} onNavigate - Callback for navigating to dropped child history
 */
const FieldDrop = ({ data, onNavigate }) => {
  // Custom hook for carousel index state
  const [index, setIndex] = useFieldDropIndex();
  // Custom hook for seen children logic
  const { getSeenFieldDropChildren, addSeenFieldDropChildren } = useSeenFieldDropChildren();

  // Track seen dropped children in localStorage
  useEffect(() => {
    const currentChild = data[index];
    // Use childCode (not childcode) for consistency with backend
    const childId = currentChild?.droppedChildDetails?.childCode;
    if (childId) {
      const seen = getSeenFieldDropChildren();
      if (!seen.includes(childId)) {
        addSeenFieldDropChildren([childId]);
      }
    }
  }, [index, data, getSeenFieldDropChildren, addSeenFieldDropChildren]);

  // Render single card or carousel depending on data length
  return (
    <Container>
      {data.length === 1 ? (
        <CardItems
          card={data[0]}
          index={0}
          totalCards={data.length}
          onNavigate={onNavigate}
        />
      ) : (
        <Carousel
          activeIndex={index}
          onSelect={setIndex}
          controls={false}
          indicators={true}
          interval={10000}
          className={`custom-carousel ${data[index]?.sections?.length === 1 ? "single-section-carousel" : " "}`}
        >
          {data.map((card, idx) => (
            <Carousel.Item key={card.id}>
              <CardItems
                card={card}
                index={idx}
                totalCards={data.length}
                onNavigate={onNavigate}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </Container>
  );
};

export default FieldDrop;
